import React from 'react';
import {
  Accept
} from 'Common/Components/Button/styled';
import { Wrapper, CancelButton } from './styled';

const Header = ({ onClose, onAccept }) => (
  <Wrapper>
    <CancelButton onClick={ onClose }>Cancel</CancelButton>
    <Accept onClick={ onAccept }>Save</Accept>
  </Wrapper>
);
export default Header;
